import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		minHeight: 0,
		minWidth: 0,
		padding: 0,
		overflow: "hidden",
		backgroundColor: theme.mode === "light" ? "#DCDCDC" : "#0B141A",
	},

	chatPapper: {
		display: "flex",
		height: "100%",
		minWidth: 0,
		overflow: "hidden",
		boxShadow: "none",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		minWidth: 0,
		minHeight: 0,
		flexDirection: "column",
		overflow: "hidden",
		backgroundColor: theme.mode === "light" ? "#FFFFFF" : "#111B21",
		borderRight: `1px solid ${theme.mode === "light" ? "#E9EDEF" : "#2A3942"}`,
	},

	messagessWrapper: {
		display: "flex",
		height: "100%",
		minWidth: 0,
		minHeight: 0,
		flexDirection: "column",
		overflow: "hidden",
		backgroundColor: theme.mode === "light" ? "#EFEAE2" : "#0B141A",
	},

	welcomeMsg: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		height: "100%",
		textAlign: "center",
		backgroundColor: theme.mode === "light" ? "#F8F9FA" : "#111B21",
		color: theme.mode === "light" ? "#54656F" : "#8696A0",
		gap: 16,
	},

	logo: {
		logo: theme.logo,
		opacity: 0.6,
	},
}));

const Chat = () => {
	const classes = useStyles();
	const { ticketId } = useParams();

	return (
		<QueueSelectedProvider>
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid item xs={4} className={classes.contactsWrapper}>
						<TicketsManagerTabs />
					</Grid>
					<Grid item xs={8} className={classes.messagessWrapper}>
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : (
							<Paper square variant="outlined" className={classes.welcomeMsg}>
								<span>
									<center>
										<img className={classes.logo} width="50%" alt="" />
									</center>
									{i18n.t("chat.noTicketMessage")}
								</span>
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		</div>
		</QueueSelectedProvider>
	);
};

export default Chat;
